import { Expose, Type } from "class-transformer";
import { Activity } from "../../../../legacy/services/activity/entities/activity/activity.entity";
import type { IActivity } from "../../../../legacy/services/activity/entities/activity/activity.entity.interface";
import { Disability } from "../../../../legacy/services/persona/entities/disability/disability.entity";
import type { IDisability } from "../../../../legacy/services/persona/entities/disability/disability.entity.interface";
import { HouseholdMemberPersona } from "../household-member-persona/household-member-persona.entity";
import type { IHouseholdMemberWithAllData } from "./household-member-with-all-data.entity.interface";

export class HouseholdMemberWithAllData extends HouseholdMemberPersona implements IHouseholdMemberWithAllData {
  @Expose()
  @Type(() => Disability)
  disabilities!: IDisability[];

  @Expose()
  @Type(() => Activity)
  activities!: IActivity[];

  @Expose()
  isComplete!: boolean;
}
